import { Car, Layers, Lightbulb, Shield, Speaker, Sparkles, Wrench, Zap } from 'lucide-react';

const ICON_MAP: Record<string, typeof Car> = {
  speaker: Speaker,
  lightbulb: Lightbulb,
  layers: Layers,
  shield: Shield,
  car: Car,
  wrench: Wrench,
  zap: Zap,
  sparkles: Sparkles,
};

export const SERVICE_ICON_KEYS = Object.keys(ICON_MAP);

export default function ServiceIcon({ name, size = 24, className = '' }: { name: string; size?: number; className?: string }) {
  const Icon = ICON_MAP[name] ?? Wrench;
  return <Icon size={size} className={className} />;
}
